import StyledActionsGroup from './styled/ActionsGroup.styled';

interface ActionGroupProps extends React.HTMLAttributes<HTMLDivElement> {
  /**
  * The children element accepts a text, a node, a function or any object inside it
  */
  children: React.ReactNode;
  [key: string]: any;
}
/**
* ActionsGroup is a div used to encapsulate action elements 
*/
const ActionsGroup =({ children = '', ...props }: ActionGroupProps) => {
  return (
    <StyledActionsGroup {...props}>
      {children}
    </StyledActionsGroup>
  );
}

export default ActionsGroup;
